export enum ProSkillManagerType {
  ALL = "ALL",
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL"
}